"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UITag = _interopRequireDefault(require("./UITag"));

var _Style = require("../core/Style");

var Colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _sizes = require("HubStyleTokens/sizes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border: ", ";\n  border-radius: 100%;\n  display: inline-block;\n  margin-right: ", ";\n\n  && {\n    /* override competing rule when used as a dropdown option avatar */\n    height: ", ";\n    width: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var statusColors = {
  disabled: Colors.BATTLESHIP,
  success: Colors.OZ,
  warning: Colors.MARIGOLD,
  danger: Colors.CANDY_APPLE,
  info: Colors.CALYPSO
};

var getDotColor = function getDotColor(color, use) {
  if (color != null) return color;
  var computedUse = _UITag.default.STATUS_ALIAS_MAP[use] || use;
  return statusColors[computedUse] || Colors[computedUse.toUpperCase().replace('-', '_')] || Colors.BATTLESHIP;
};

var UIStatusDot = _styledComponents.default.span.withConfig({
  displayName: "UIStatusDot",
  componentId: "sc-1ec0adk-0"
})(_templateObject(), function (_ref) {
  var color = _ref.color,
      hollow = _ref.hollow,
      use = _ref.use;
  return !hollow && getDotColor(color, use);
}, function (_ref2) {
  var color = _ref2.color,
      hollow = _ref2.hollow,
      use = _ref2.use;
  return hollow && "2px solid " + getDotColor(color, use);
}, (0, _Style.remCalc)(_sizes.TAG_ICON_SPACING_X), (0, _Style.remCalc)(10), (0, _Style.remCalc)(10));

UIStatusDot.propTypes = {
  color: _react.PropTypes.string,
  hollow: _react.PropTypes.bool.isRequired,
  use: _UITag.default.propTypes.use
};
UIStatusDot.defaultProps = {
  hollow: false,
  use: 'info'
};
UIStatusDot.getDotColor = getDotColor; // expose for tests

var _default = UIStatusDot;
exports.default = _default;
module.exports = exports.default;